// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__30uOU","upload":"Small_upload__32LSu","imageWrap":"Small_imageWrap__17Kyh","removeBtn":"Small_removeBtn__3VEkz"};